const commentItems = [
  {
    name: '追剧小达人',
    time: '2小时前',
    content: '蓝莓影院真的太良心了！苍穹之刃更新速度全网最快，画质还这么好，已经安利给身边所有朋友了。不收费不卡顿，这才是真正的观影平台。',
    likes: '2.3k',
  },
  {
    name: '电影爱好者Leo',
    time: '5小时前',
    content: '用了大半年了，资源丰富程度超出预期。很多冷门高分片在其他平台找不到，这里都有。而且每天更新的内容质量很高，编辑推荐很靠谱。',
    likes: '1.8k',
  },
  {
    name: '深夜观影人',
    time: '昨天 23:15',
    content: '暗夜追光者每一集都在这里追的，真的是秒开不缓冲。半夜躺在床上用手机看，画质调到1080P也完全流畅。蓝莓影院移动端的适配做得很到位。',
    likes: '1.5k',
  },
  {
    name: '武侠迷老张',
    time: '昨天 18:40',
    content: '竟然找到了小时候看的经典武侠片高清修复版，太感动了！从邵氏经典到新派武侠都有收录，这对我们这些老影迷来说简直是宝藏平台。祝蓝莓影院越做越好！',
    likes: '967',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">观众评价</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">来自真实观众的观影反馈，你的感受和他们一样吗？</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {commentItems.map((c) => (
            <div
              key={c.name}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                  <span className="font-heading text-sm text-primary-600">{c.name.charAt(0)}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-sm text-foreground-900">{c.name}</div>
                  <div className="text-xs text-foreground-400">{c.time}</div>
                </div>
                <div className="flex items-center gap-1 text-xs text-accent-500 shrink-0">
                  <i className="ri-thumb-up-line"></i>
                  <span>{c.likes}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{c.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}